import React from "react";

interface Props {
  name: IconName;
  viewBox: string;
  alt: string;
  svg: string;
  className?: string;
  id?: string;
}

/**
 * Main ICON component for the web parts written in React.
 * @param {string} name - The name of the icon.
 * @param {string} viewBox - The viewBox attribute of the SVG element.
 * @param {string} alt - Provides the SVG element with an accessible name via 'aria-labelledby'.
 * @param {string} svg - The SVG string to render.
 * @param {string} [className] - [optional] The className attribute of the SVG element.
 * @param {string} [id] - [optional] The ID of the SVG element.
 *
 * @returns {ReactElement} Rendered SVG element.
 */

const Icon: React.FC<Props> = ({ name, viewBox, alt, svg, className, id }) => {
  return (
    <svg
      data-name={name}
      viewBox={viewBox}
      aria-labelledby={alt}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svg }}
      className={className}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
    />
  );
};

export default Icon;
